import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Binoculars glyph for the Price Promo Watchlist (Material Design Icons
 * "binoculars" path — @mui/icons-material has no binoculars icon).
 */
const BinocularsIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props}>
    <path d="M11,6H13V13H11V6M9,20A1,1 0 0,1 8,21H5A1,1 0 0,1 4,20V15L6,7H10V13A1,1 0 0,1 9,14V20M10,5H7V3H10V5M15,20V14A1,1 0 0,1 14,13V7H18L20,15V20A1,1 0 0,1 19,21H16A1,1 0 0,1 15,20M14,5V3H17V5H14Z" />
  </SvgIcon>
);

export default BinocularsIcon;
